export default __webpack_public_path__ + "static/media/valid_link_hero_image.d547802b.png";